document.addEventListener('DOMContentLoaded', function() {
  // Inicializar grids en la página
  const gridSections = document.querySelectorAll('.advanced-grid-section');
  
  gridSections.forEach(section => {
    const gridContainer = section.querySelector('.advanced-grid-container');
    
    // Hacer los items arrastrables (requiere la librería interact.js)
    if (typeof interact === 'function') {
      initDraggableGrid(gridContainer);
    }
    
    // Añadir controles de edición en el editor de Shopify
    if (Shopify.designMode) {
      initDesignModeControls(gridContainer);
    }
  });

  testimonials_container()

  if (window.innerWidth < 800) {
    bajo_hero_slider()
    box_slider()
    versus_body()
  }
  
  function initDraggableGrid(grid) {
    interact('.grid-item', {
      context: grid
    }).draggable({
      inertia: true,
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: 'parent',
          endOnly: true
        })
      ],
      autoScroll: true,
      listeners: {
        move: dragMoveListener
      }
    });
    
    function dragMoveListener(event) {
      const target = event.target;
      const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
      const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
      
      target.style.transform = `translate(${x}px, ${y}px)`;
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    }
  }
  
  function initDesignModeControls(grid) {
    const sectionId = grid.closest('[data-section-id]').dataset.sectionId;
    
    // Añadir botones de control a cada item
    grid.querySelectorAll('.grid-item').forEach(item => {
      const controls = document.createElement('div');
      controls.className = 'grid-item-design-controls';
      controls.innerHTML = `
        <button class="edit-item" data-block-id="${item.dataset.blockId}">✏️</button>
        <button class="move-item">↔️</button>
        <button class="delete-item" data-block-id="${item.dataset.blockId}">🗑️</button>
      `;
      item.appendChild(controls);
      
      // Manejar eventos
      controls.querySelector('.edit-item').addEventListener('click', function() {
        const blockId = this.dataset.blockId;
        Shopify.section.selectBlock(blockId);
      });
      
      controls.querySelector('.delete-item').addEventListener('click', function() {
        if (confirm('¿Eliminar este elemento?')) {
          const blockId = this.dataset.blockId;
          Shopify.section.removeBlock(blockId);
        }
      });
    });
    
    // Añadir controles de sección
    const sectionControls = document.createElement('div');
    sectionControls.className = 'grid-section-controls';
    sectionControls.innerHTML = `
      <button class="add-item" data-type="text">Añadir Texto</button>
      <button class="add-item" data-type="image">Añadir Imagen</button>
      <button class="add-item" data-type="product">Añadir Producto</button>
      <button class="add-item" data-type="collection">Añadir Colección</button>
    `;
    grid.parentNode.insertBefore(sectionControls, grid);
    
    sectionControls.querySelectorAll('.add-item').forEach(button => {
      button.addEventListener('click', function() {
        const type = this.dataset.type;
        Shopify.section.addBlock(sectionId, {
          type: type,
          settings: getDefaultSettingsForType(type)
        });
      });
    });
  }
  
  function getDefaultSettingsForType(type) {
    const defaults = {
      text: {
        text: '<p>Nuevo texto</p>',
        text_alignment: 'left',
        text_color: '#000000',
        column_start: 1,
        column_end: 1,
        row_start: 1,
        row_end: 1,
        mobile_column_start: 1,
        mobile_column_end: 1
      },
      // ... defaults para otros tipos
    };
    
    return defaults[type] || {};
  }

  function bajo_hero_slider() {
    jQuery('.bajo-hero').slick({
      autoplay: true,
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 769, // Activar hasta 768px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 9999, // Desactivar a partir de 769px
        settings: "unslick"
      }]
    });
  }
  function box_slider() {
    jQuery('.box-slider').slick({
      autoplay: true,
      dots: true,
      arrows: false,
      infinite: false,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // prevArrow: '<button type="button" class="slick-prev bajo-hero-slick-prev"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      // nextArrow: '<button type="button" class="slick-next bajo-hero-slick-next"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [{
        breakpoint: 769, // Activar hasta 768px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 9999, // Desactivar a partir de 769px
        settings: "unslick"
      }]
    });
  }
  function versus_body() {
    jQuery('.versus-body').slick({
      autoplay: true,
      dots: false,
      arrows: true,
      infinite: false,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev versus-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="11.9938" cy="11.9938" r="11.9938" fill="#6B7653"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7163 16.9113C15.0186 17.2112 15.0186 17.6999 14.7163 17.9998C14.4174 18.2966 13.935 18.2966 13.636 17.9998L8.40624 12.8098L8.40305 12.8066C8.40305 12.8066 8.40301 12.8066 8.94731 12.2664L8.40305 12.8066C8.10244 12.5083 8.1024 12.0246 8.40301 11.7263L13.6361 6.53299C13.935 6.23628 14.4174 6.23628 14.7163 6.53299C15.0186 6.83291 15.0186 7.32163 14.7163 7.62156L10.0359 12.2664L14.7163 16.9113Z" fill="white"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next versus-slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="11.9938" cy="11.9938" r="11.9938" transform="rotate(-180 11.9938 11.9938)" fill="#6B7653"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.2712 7.07628C8.96898 6.77635 8.96898 6.28763 9.2712 5.98771C9.57018 5.691 10.0525 5.691 10.3515 5.98771L15.5813 11.1778L15.5845 11.1809C15.5845 11.1809 15.5845 11.181 15.0402 11.7211L15.5845 11.1809C15.8851 11.4793 15.8852 11.963 15.5845 12.2613L10.3515 17.4546C10.0525 17.7513 9.57018 17.7513 9.2712 17.4546C8.96898 17.1546 8.96898 16.6659 9.2712 16.366L13.9516 11.7211L9.2712 7.07628Z" fill="white"/></svg></button>',
      responsive: [{
        breakpoint: 769, // Activar hasta 768px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 9999, // Desactivar a partir de 769px
        settings: "unslick"
      }]
    });
  }
  function testimonials_container() {
    jQuery('#testimonials-container').slick({
      autoplay: true,
      dots: false,
      arrows: true,
      infinite: true,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<svg class="slick-prev bajo-hero-slick-prev" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="14.7697" cy="14.7697" r="14.7697" fill="#6B7653"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.1224 20.8253C18.4945 21.1946 18.4945 21.7965 18.1224 22.1658C17.7542 22.5312 17.1602 22.5312 16.792 22.1658L10.3518 15.7746L10.3479 15.7707C10.3479 15.7707 10.3478 15.7706 11.0181 15.1054L10.3479 15.7707C9.9777 15.4033 9.97765 14.8076 10.3478 14.4402L16.792 8.04503C17.1602 7.67966 17.7542 7.67965 18.1224 8.04503C18.4945 8.41438 18.4945 9.01621 18.1224 9.38555L12.3587 15.1054L18.1224 20.8253Z" fill="white"/></svg>',
      nextArrow: '<svg class="slick-next bajo-hero-slick-next" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="14.7697" cy="14.7697" r="14.7697" transform="rotate(-180 14.7697 14.7697)" fill="#6B7653"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.417 8.714C11.0448 8.34466 11.0448 7.74283 11.417 7.37349C11.7851 7.00811 12.3791 7.00811 12.7473 7.37349L19.1875 13.7647L19.1914 13.7687C19.1914 13.7687 19.1915 13.7687 18.5212 14.4339L19.1914 13.7687C19.5616 14.136 19.5617 14.7317 19.1915 15.0991L12.7473 21.4943C12.3791 21.8597 11.7851 21.8597 11.417 21.4943C11.0448 21.1249 11.0448 20.5231 11.417 20.1538L17.1807 14.4339L11.417 8.714Z" fill="white"/></svg>',
      responsive: [{
        breakpoint: 769, // Activar hasta 768px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px'
        }
      }]
    });
  }
});

// Estilos para el modo diseño
if (Shopify.designMode) {
  const style = document.createElement('style');
  style.textContent = `
    .grid-item-design-controls {
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 10;
      display: flex;
      gap: 5px;
    }
    
    .grid-item-design-controls button {
      background: rgba(255,255,255,0.8);
      border: 1px solid #ddd;
      border-radius: 3px;
      cursor: pointer;
      padding: 2px 5px;
    }
    
    .grid-section-controls {
      display: flex;
      gap: 10px;
      margin-bottom: 15px;
      flex-wrap: wrap;
    }
    
    .grid-section-controls button {
      background: #fff;
      border: 1px solid #ddd;
      padding: 5px 10px;
      cursor: pointer;
    }
    
    .grid-item:hover {
      outline: 2px dashed #4285f4;
    }
  `;
  document.head.appendChild(style);
}

document.addEventListener('DOMContentLoaded', function () {
  const select = document.querySelector('#SortBy');

  if (select) {
    const option = document.createElement('option');
    option.text = 'Ordenar por:';
    option.value = '';
    option.disabled = false;
    option.selected = true;

    select.insertBefore(option, select.firstChild);
  }
});